import { Expose } from 'class-transformer';
import {
  IS_STOCK_USER,
  KYC_STATUS,
  FRAUD_STATUS,
  OVERDUE_STATUS,
  IS_FIRST_IN,
  RISK_REJECT_CODE,
  BIZ_TYPE,
  LOCK_TYPE,
  UC_USER_STATUS,
  UC_SCREEN_STATUS,
  USER_TOTAL_STATUS,
} from './userInfo.interface';

export class UserInfoModel {
  @Expose()
  userId?: string;

  @Expose()
  userTotalStatus!: USER_TOTAL_STATUS;

  @Expose()
  userStatus!: UC_USER_STATUS;

  /** UC lock_info_list；expire_time 为 UC 为 Risk Temp Freeze 新增的过期时间戳（秒，同 cool_down_end_time），只有相关记录才带 */
  @Expose()
  lockInfoList!: { biz_type: BIZ_TYPE; lock_type: LOCK_TYPE; expire_time?: number }[];

  @Expose()
  isStockUser!: IS_STOCK_USER;

  @Expose()
  screenStatus!: UC_SCREEN_STATUS;

  @Expose()
  kycStatus!: KYC_STATUS;

  @Expose()
  fraudStatus!: FRAUD_STATUS;

  @Expose()
  overdueStatus!: OVERDUE_STATUS;

  // @Expose()
  // toggleStatus: ITypes.UC_TOGGLE_STATUS

  @Expose()
  totalLimit!: number;

  @Expose()
  availableLimit!: number;

  @Expose()
  isFirstIn!: IS_FIRST_IN;

  @Expose()
  riskRejectCode!: RISK_REJECT_CODE;

  @Expose()
  coolDownEndTime!: number;

  @Expose()
  islogin!: boolean;

  @Expose()
  isFrozen!: boolean;

  @Expose()
  isKYCFrozen!: boolean;

  @Expose()
  isKYCFrozenWithUpdateInfo!: boolean;

  @Expose()
  isKYCFrozenWithUpdateInfoPending!: boolean;

  @Expose()
  isKYCFrozenWithoutUpdateInfo!: boolean;

  @Expose()
  isFraudFrozen!: boolean;

  @Expose()
  isOverdueFrozen!: boolean;

  @Expose()
  isSellerFrozen!: boolean;

  @Expose()
  isCNPJFrozen!: boolean;

  @Expose()
  isICFrozen!: boolean;

  @Expose()
  isFSKYCFrozen!: boolean;

  @Expose()
  isUnactivated!: boolean;

  @Expose()
  isUnderFrozen!: boolean;

  @Expose()
  isAccountClosureFrozen!: boolean;

  @Expose()
  isCollectionFrozen!: boolean;

  @Expose()
  isShopeeStatusFrozen!: boolean;

  @Expose()
  isDPD60Frozen!: boolean;

  @Expose()
  isPaymentRejectCoolDownFrozen!: boolean;

  @Expose()
  isTemporaryUnderwritingFrozen!: boolean;

  @Expose()
  isRiskTempFrozen!: boolean;

  @Expose()
  isSPPFrozen!: boolean;

  @Expose()
  isSPPUnlinkFrozen!: boolean;

  @Expose()
  isContractFrozen!: boolean;

  @Expose()
  isCICFrozen!: boolean;

  @Expose()
  isOtherCreditOverdueFrozen!: boolean;

  @Expose()
  isDPDFrozen!: boolean;

  @Expose()
  isShopeeAccountFrozen!: boolean;

  @Expose()
  isContractUnsigned!: boolean;

  @Expose()
  isCDDWillExpire!: boolean;

  @Expose()
  isCDDExpired!: boolean;

  // @Expose()
  // needUpdateInfo!: boolean
}
